import Vue from 'vue'
import Router from 'vue-router'
import Login from './components/Login.vue'

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {path: '/sensors'},
    {path: '/sensors/area/:areaId'},
    {path: '/:id/:view'},
    {
      path: '*',
      redirect: () => {
        const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true'
        return isAuthenticated ? '/0/clients' : '/login'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem('isAuthenticated') === 'true'

  if (to.path === '/login')
    if (isAuthenticated)
      next('/0/clients')
    else
      next()
  else if (to.path !== '/login')
    if (!isAuthenticated)
      next('/login')
    else
      next()
  else
    next()
})

export default router
